export default {
  "content": "<path d=\"M0 0h48v48H0z\" fill=\"none\"/><path d=\"M14 7h20v6H14z\" fill=\"#D7D8DE\"/><g fill=\"#3F4450\"><path d=\"M24 40c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\"/><path d=\"M36 0H12c-1.654 0-3 1.346-3 3v42c0 1.654 1.346 3 3 3h24c1.654 0 3-1.346 3-3V3c0-1.654-1.346-3-3-3zm1 45c0 .551-.448 1-1 1H12c-.552 0-1-.449-1-1V3c0-.551.448-1 1-1h24c.552 0 1 .449 1 1z\"/><path d=\"M13 38h22V6H13zm2-2V14h18v22zM33 8v4H15V8z\"/></g>",
  "attrs": {
    "viewBox": "0 0 48 48",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};